export default "__VITE_ASSET__2648c88d__"